import { useStoreProfiles } from '../../store/useStoreProfiles'
import { storeToRefs } from 'pinia'

/**Only return what values we need to update on a store, rather than the
 * whole store itself, which is a large join of many different tables.
 */
export const getStoreEditedData = () => {
  const { getEditedStores } = storeToRefs(useStoreProfiles())
  if (getEditedStores.value.length < 1) return null
  return getEditedStores.value.map((store) => {
    const {
      store_id,
      no_of_coupon_zones,
      manned_checkout_number,
      self_checkout_number,
      cart_size_id,
      cart_count,
      pedestal_id,
      no_of_pedestals,
      contact_name,
      notes,
    } = store
    return {
      store_id,
      no_of_coupon_zones,
      manned_checkout_number,
      self_checkout_number,
      cart_size_id,
      cart_count,
      pedestal_id,
      no_of_pedestals,
      contact_name,
      notes,
    }
  })
}
